<template>
    <div>
        <b-row class="align-items-end">
            <b-col :cols="fieldCols">
                <label class="mb-1">Period Start</label>
                <el-date-picker :value="periodStart" type="date" format="MM/dd/yyyy" value-format="yyyy-MM-dd"
                    style="width: 100%" @input="$emit('update:periodStart', $event)" />
            </b-col>
            <b-col :cols="fieldCols">
                <label class="mb-1">Period End</label>
                <el-date-picker :value="periodEnd" type="date" format="MM/dd/yyyy" value-format="yyyy-MM-dd"
                    style="width: 100%" @input="$emit('update:periodEnd', $event)" />
            </b-col>
            <b-col :cols="fieldCols">
                <label class="mb-1">Due By</label>
                <el-date-picker :value="dueByDate" type="date" format="MM/dd/yyyy" value-format="yyyy-MM-dd"
                    style="width: 100%" @input="$emit('update:dueByDate', $event)" />
            </b-col>
            <b-col v-if="hasAction" cols="3" class="text-right">
                <slot />
            </b-col>
        </b-row>

        <b-alert :show="!valid" variant="warning" class="mt-2">
            Period End must fall on or after Period Start.
        </b-alert>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { DatePicker } from "element-ui";
import { arIsValidStatementPeriod } from "@/models/AR";

/**
 * The Period Start / Period End / Due By trio shared by the single-statement generator and the
 * monthly batch page. Both run the same server-side generation, so they get the same date contract
 * and the same inverted-range warning from here rather than from two hand-kept copies.
 *
 * The action button is a slot: the callers disable it on different conditions and some confirm
 * before running. Callers that own their own buttons — a modal with a footer, say — leave the slot
 * empty, and the three date fields spread to fill the row instead of leaving a gap.
 */
@Component({
    name: "ARStatementPeriodFields",
    components: {
        [DatePicker.name]: DatePicker,
    },
})
export default class ARStatementPeriodFields extends Vue {
    @Prop({ type: String, default: "" }) periodStart!: string;
    @Prop({ type: String, default: "" }) periodEnd!: string;
    @Prop({ type: String, default: "" }) dueByDate!: string;

    get valid(): boolean {
        return arIsValidStatementPeriod(this.periodStart, this.periodEnd);
    }

    get hasAction(): boolean {
        return !!this.$slots.default || !!this.$scopedSlots.default;
    }

    /** Three across when the caller supplies an inline action, four across when it does not. */
    get fieldCols(): number {
        return this.hasAction ? 3 : 4;
    }
}
</script>

<style scoped></style>
